export default [
  {
    query: 'magnesium',
    suggestions: ['sport', 'verla', 'pure', 'sticks', 'brausetabletten'],
  },
  {
    query: 'Nasenspray',
    suggestions: ['kinder', 'ratiopharm', 'allergie', 'baby', 'nasivin'],
  },
  {
    query: 'Wick',
    suggestions: [
      'vaporub',
      'nasenspray',
      'inhalierstift',
      'hustensaft',
      'husten',
    ],
  },
  {
    query: 'pflaster',
    suggestions: [
      'kinderpflaster',
      'wasserfest',
      'sensitive',
      'pflasterspray',
      'groß',
    ],
  },
  {
    query: 'la roche posay',
    suggestions: [
      'anthelios',
      'effaclar',
      'sonnenschutz',
      'toleriane',
      'lipikar',
    ],
  },
  {
    query: 'omni',
    suggestions: [
      'biotic',
      'biotic 6',
      'omniflora',
      'biotic stress',
      ' biotic metabolic',
    ],
  },
  {
    query: 'vitamin d',
    suggestions: ['hochdosiert', 'loges', '3', 'kapseln', 'k2'],
  },
  {
    query: 'sonnentor',
    suggestions: ['tee', 'gewürz', 'sirup', 'salz', 'kekse'],
  },
  {
    query: 'augentropfen',
    suggestions: [
      'trockene augen',
      'allergie',
      'hylo',
      'bepanthen',
      'kontaktlinsen',
    ],
  },
  {
    query: 'pure',
    suggestions: ['encapsulations', 'magnesium', 'zink', 'vitamin', 'eisen'],
  },
  {
    query: 'vichy',
    suggestions: ['deodorant', 'sonnen', 'normaderm', 'neovadiol', 'liftactiv'],
  },
  {
    query: 'eucerin',
    suggestions: ['sonne', 'pigment', 'hyaluron', 'atopicontrol', 'dermopure'],
  },
  {
    query: 'mariendistel',
    suggestions: ['kapseln', 'artischocke', 'öl', 'dr', 'tee'],
  },
  {
    query: 'eisen',
    suggestions: [
      'eisenmangel',
      'eisentabletten',
      'eisensaft',
      'kinder',
      'pure',
    ],
  },
  {
    query: 'zink',
    suggestions: ['zinksalbe', 'pure', 'selen', 'zinkletten', 'zinkorotat'],
  },
  {
    query: 'Vitamin c',
    suggestions: ['serum', '1000', 'pulver', 'pure', 'brausetabletten'],
  },
  {
    query: 'weleda',
    suggestions: ['baby', 'augentropfen', 'calendula', 'duschgel', 'zahncreme'],
  },
  {
    query: 'primavera',
    suggestions: [
      'hustensaft',
      'hustensaft kinder',
      'hustenstiller',
      'hustentropfen',
      'hustentee',
    ],
  },
  {
    query: 'Avéne',
    suggestions: [
      'sonnenmilch',
      'cleanance',
      'hydrance',
      'tolerance',
      'reinigungslotion',
    ],
  },
]
